import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Post } from "../models/post";
import { PostStats } from "../models/post-stats";
import { SignedAcceptanceTerm } from "../models/signed-acceptance-term";
import { Poll } from "../models/poll";
import { PollVote } from "../models/poll-vote";

@Injectable({
    providedIn: 'root'
})

export class PostService {
    constructor(private http: HttpClient) { }

    getPosts(params?) {
        return this.http.get<Post[]>(`${environment.API}posts`, { params }).pipe();
    }

    createPost(body) {
        return this.http.post<any>(`${environment.API}posts`, body).pipe();
    }

    updatePost(postID: number, body) {
        return this.http.put<any>(`${environment.API}posts/${postID}`, body).pipe();
    }

    deletePost(postID: number) {
        return this.http.delete<any>(`${environment.API}posts/${postID}`).pipe();
    }

    readPost(postID: number, body) {
        return this.http.post<any>(`${environment.API}posts/${postID}/read`, body).pipe();
    }

    ratePost(postID: number, body) {
        return this.http.post<any>(`${environment.API}posts/${postID}/like`, body).pipe();
    }

    acceptPostAcceptanceTerm(body) {
        const postID = body.get('postID');
        return this.http.post<any>(`${environment.API}posts/${postID}/acceptance-term/accept`, body).pipe();
    }

    getPostStats(params?) {
        return this.http.get<PostStats>(`${environment.API}posts/${params?.id}/stats`).pipe();
    }

    getSignedAcceptanceTerm(params) {
        const { legalPostID, ...rest } = params;
        return this.http.get<SignedAcceptanceTerm>(`${environment.API}posts/${legalPostID}/acceptance-term/signatures`, { params: rest }).pipe();
    }

    getPolls(params?) {
        return this.http.get<Poll[]>(`${environment.API}polls`, { params }).pipe();
    }

    createPoll(body) {
        return this.http.post<any>(`${environment.API}polls`, body).pipe();
    }

    deletePoll(pollID: number) {
        return this.http.delete<any>(`${environment.API}polls/${pollID}`).pipe();
    }

    voteInPoll(body) {
        const { pollID, ...rest } = body;
        return this.http.post<any>(`${environment.API}polls/${pollID}/vote`, rest).pipe();
    }

    getPollVotes(pollID: number, params?) {
        return this.http.get<PollVote[]>(`${environment.API}polls/${pollID}/votes`, { params }).pipe();
    }
}
